import { useSrpContext } from '@/src/contexts'
import { useTranslations } from 'next-intl'

import FareIntelligence from './fareIntelligence'

const FareIntelligenceWrapper = () => {
    const {
        SEOSrpData: { sections }
    } = useSrpContext()
    const t = useTranslations('common.routeSeoContent')

    const whenToBook = sections?.whenToBook
    if (!whenToBook?.fareOverview) return null

    const currency = whenToBook.fareSummary?.currency ?? 'SAR'
    const rawFares = whenToBook.monthlyBreakdown ?? []
    const maxFare = Math.max(...rawFares.map(f => Number(f.avgFare) || 0), 1)

    const monthlyFares = rawFares.map(f => {
        const fare = Number(f.avgFare) || 0
        return {
            shortLabel: f.month.slice(0, 3),
            value: fare,
            heightPercent: (fare / maxFare) * 100,
        }
    })

    return (
        <FareIntelligence
            fareOverview={whenToBook.fareOverview}
            bookingAdvice={whenToBook.bookingAdvice}
            weekendVsWeekday={whenToBook.weekendVsWeekday}
            monthlyFares={monthlyFares}
            monthlyChartTitle={t('monthlyAverageFare')}
            monthlyUnit={t('perMonth', { currency })}
        />
    )
}

export default FareIntelligenceWrapper
